import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useApp } from '../contexts/AppContext';

export default function Navbar() {
  const { t, lang, toggleLang, user, logout } = useApp();
  const navigate = useNavigate();
  const [open, setOpen] = useState(false);

  const handleLogout = () => {
    logout();
    navigate('/');
    setOpen(false);
  };

  return (
    <nav className="navbar-summer">
      <div className="container">
        <div className="d-flex align-items-center justify-content-between">

          {/* Logo — always goes to homepage */}
          <Link to="/" className="d-flex align-items-center gap-2 text-decoration-none">
            <img src="/logo.png" alt="Ryukyu GLOCAL" style={{ height: 44, mixBlendMode: 'multiply' }} />
            <div>
              <div style={{ fontWeight: 900, fontSize: '1rem', color: 'var(--orange)', lineHeight: 1.1 }}>
                {t.siteName}
              </div>
              <div style={{ fontSize: '0.65rem', fontWeight: 700, color: 'var(--muted)', letterSpacing: '0.5px' }}>
                {t.siteSubtitle}
              </div>
            </div>
          </Link>

          {/* Desktop Nav */}
          <div className="d-none d-md-flex align-items-center gap-3">
            <div className="lang-switcher">
              <button className={`lang-btn ${lang === 'ja' ? 'active' : ''}`} onClick={() => lang !== 'ja' && toggleLang()}>日本語</button>
              <button className={`lang-btn ${lang === 'en' ? 'active' : ''}`} onClick={() => lang !== 'en' && toggleLang()}>EN</button>
            </div>

            <Link to="/curriculum" className="btn-outline-summer py-1 px-3 text-decoration-none" style={{ fontSize: '0.85rem' }}>
              📚 {lang === 'ja' ? 'カリキュラム' : 'Curriculum'}
            </Link>

            {!user && (
              <Link to="/login" className="btn-summer py-1 px-3 text-decoration-none" style={{ fontSize: '0.85rem' }}>
                {t.login}
              </Link>
            )}

            {user && (
              <>
                <span style={{ fontWeight: 700, fontSize: '0.9rem' }}>👋 {user.name}</span>
                {user.role === 'student' && (
                  <Link to="/profile" className="btn-outline-summer py-1 px-3 text-decoration-none" style={{ fontSize: '0.85rem' }}>
                    {t.myProfile}
                  </Link>
                )}
                {(user.role === 'teacher' || user.role === 'admin') && (
                  <Link to="/dashboard" className="btn-outline-summer py-1 px-3 text-decoration-none" style={{ fontSize: '0.85rem' }}>
                    {t.dashboard}
                  </Link>
                )}
                {(user.role === 'teacher' || user.role === 'admin') && (
                  <Link to="/orientation" className="btn-outline-summer py-1 px-3 text-decoration-none" style={{ fontSize: '0.85rem' }}>
                    🎤 {lang === 'ja' ? 'オリエンテーション' : 'Orientation'}
                  </Link>
                )}
                {(user.role === 'teacher' || user.role === 'admin') && (
                  <Link to="/roulette" className="btn-outline-summer py-1 px-3 text-decoration-none" style={{ fontSize: '0.85rem' }}>
                    🎡 {lang === 'ja' ? 'ルーレット' : 'Roulette'}
                  </Link>
                )}
                <button onClick={handleLogout} className="btn-summer py-1 px-3" style={{ fontSize: '0.85rem' }}>
                  {t.logout}
                </button>
              </>
            )}
          </div>

          {/* Mobile toggle */}
          <button className="d-md-none border-0 bg-transparent fs-4" onClick={() => setOpen(!open)}>
            {open ? '✕' : '☰'}
          </button>
        </div>

        {/* Mobile menu */}
        {open && (
          <div className="d-md-none mt-3 pb-2 border-top pt-3" style={{ borderColor: '#F3F4F6' }}>
            <div className="d-flex flex-column gap-3">
              <div className="lang-switcher align-self-start">
                <button className={`lang-btn ${lang === 'ja' ? 'active' : ''}`} onClick={() => { lang !== 'ja' && toggleLang(); setOpen(false); }}>日本語</button>
                <button className={`lang-btn ${lang === 'en' ? 'active' : ''}`} onClick={() => { lang !== 'en' && toggleLang(); setOpen(false); }}>EN</button>
              </div>
              <Link to="/curriculum" onClick={() => setOpen(false)} className="text-decoration-none fw-bold" style={{ color: 'var(--orange)' }}>
                📚 {lang === 'ja' ? 'カリキュラム' : 'Curriculum'}
              </Link>
              {!user && (
                <Link to="/login" onClick={() => setOpen(false)} className="btn-summer align-self-start text-decoration-none">
                  {t.login}
                </Link>
              )}
              {user && (
                <>
                  <span style={{ fontWeight: 700 }}>👋 {user.name}</span>
                  {user.role === 'student' && (
                    <Link to="/profile" onClick={() => setOpen(false)} className="text-decoration-none fw-bold" style={{ color: 'var(--orange)' }}>{t.myProfile}</Link>
                  )}
                  {(user.role === 'teacher' || user.role === 'admin') && (
                    <Link to="/dashboard" onClick={() => setOpen(false)} className="text-decoration-none fw-bold" style={{ color: 'var(--orange)' }}>{t.dashboard}</Link>
                  )}
                  {(user.role === 'teacher' || user.role === 'admin') && (
                    <Link to="/orientation" onClick={() => setOpen(false)} className="text-decoration-none fw-bold" style={{ color: 'var(--orange)' }}>
                      🎤 {lang === 'ja' ? 'オリエンテーション' : 'Orientation'}
                    </Link>
                  )}
                  {(user.role === 'teacher' || user.role === 'admin') && (
                    <Link to="/roulette" onClick={() => setOpen(false)} className="text-decoration-none fw-bold" style={{ color: 'var(--orange)' }}>
                      🎡 {lang === 'ja' ? 'ルーレット' : 'Roulette'}
                    </Link>
                  )}
                  <button onClick={handleLogout} className="btn-summer align-self-start">{t.logout}</button>
                </>
              )}
            </div>
          </div>
        )}
      </div>
    </nav>
  );
}
